export const MAILTO_URL = "mailto:info@bikadraj.com";
export const INSTAGRAM_URL = "https://www.instagram.com/bikadraj.media";
export const SITE_URL = "https://bikadraj.com";
export const EMAIL = "info@bikadraj.com";
